import React from 'react';
import classnames from 'classnames';

import useIntersection from 'hooks/useIntersection';
import * as styles from './testimonial.module.scss';

const Testimonial = ({ data }) => {
  const { scrollWrapper, inViewSec, inViewRefSec } = useIntersection({
    threshold: 0.7,
  });

  return (
    <div className={classnames(styles.testimonial)} ref={scrollWrapper}>
      <div
        className={classnames(styles.inner, inViewSec && styles.jsAnimInit)}
        ref={inViewRefSec}
      >
        <picture className={classnames(styles.testimonial_imgAuthorWrap)}>
          {data.author_photo && (
            <img
              src={data.author_photo}
              alt={data.first_name + ' ' + data.last_name}
            />
          )}
        </picture>

        <blockquote className={classnames(styles.testimonial_blockquote)}>
          <p className={classnames('cr-lead')}>
            {data.bloquote && data.bloquote}
          </p>
        </blockquote>

        <div className={classnames(styles.testimonial_info)}>
          <div>
            <h5 className={classnames('cr-h5 cr-main')}>
              {data.first_name && data.last_name
                ? data.first_name + ' ' + data.last_name
                : ''}
            </h5>
            <p className={classnames('cr-reg cr-text-1 cr-opacity-05')}>
              {data.position && data.position}
            </p>
          </div>

          <picture className={classnames(styles.logoWrap)}>
            {data.company_logo && (
              <img src={data.company_logo} alt={data.company_logo} />
            )}
          </picture>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
